import Vue from 'vue'
import App from './App.vue'
// import store from './service/store.js'

import 'bootstrap'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'video.js/dist/video-js.min.css'

import "./assets/tabulator.min.css"


import * as sliders from 'd3-simple-slider'

require('../node_modules/@fortawesome/fontawesome-free/css/all.css');

import _ from 'lodash'
window._ = _

import * as d3 from 'd3'
window.d3 = d3
window.d3.sliders = sliders
import * as d3plus from "d3plus-text"
window.d3plus = d3plus

import $ from 'jquery'
window.$ = $

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
